import { render } from "./FooterBottom.vue?vue&type=template&id=7ed91719&scoped=true"
import script from "./FooterBottom.vue?vue&type=script&lang=js"
export * from "./FooterBottom.vue?vue&type=script&lang=js"

import "./FooterBottom.vue?vue&type=style&index=0&id=7ed91719&lang=scss&scoped=true"

import exportComponent from "E:\\Project\\UGit\\heronlink\\web\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ed91719"]])

export default __exports__